module.exports = __webpack_public_path__ + "img/Pinterest.98926e84.svg";